import { Anchor, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <Stack gap="md">
      <Title order={2}>Not found</Title>
      <Text c="dimmed">No route matched this URL.</Text>
      <Anchor component={Link} to="/batches">
        Go to batches →
      </Anchor>
    </Stack>
  );
}
